import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { INVOICE_TABLE_TAB_FILTERS } from '@css-xp/ppc-constants';

export const getCommonQuerySearchOptions = (
  sortOptions: generatedTypesNew.SortType,
  searchOptions?: generatedTypesNew.SearchOptions,
  rowsPerPage?: number
) => {
  return {
    first: rowsPerPage,
    sort: sortOptions,
    offset: 0,
    ...searchOptions,
  };
};

export const getFilterOptions = ({
  shouldShowDeferredInvoicesColumns = false,
  filters,
}: {
  shouldShowDeferredInvoicesColumns?: boolean;
  filters: generatedTypesNew.FilterOption[] | Record<string, string>[];
}) => {
  if (shouldShowDeferredInvoicesColumns && filters) {
    return {
      and: [{ or: filters }, { or: INVOICE_TABLE_TAB_FILTERS }],
    };
  }
  return filters?.length > 0
    ? {
        and: [{ or: INVOICE_TABLE_TAB_FILTERS }],
        or: [...filters],
      }
    : {
        and: [{ or: INVOICE_TABLE_TAB_FILTERS }],
      };
};
